var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NavController, MenuController, ViewController, Events } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { ApiProvider } from '../../providers/api/api';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
var CommonHeaderComponent = /** @class */ (function () {
    function CommonHeaderComponent(navCtrl, menu, viewCtrl, events, comProv, apiProv, gaProv) {
        var _this = this;
        this.navCtrl = navCtrl;
        this.menu = menu;
        this.viewCtrl = viewCtrl;
        this.events = events;
        this.comProv = comProv;
        this.apiProv = apiProv;
        this.gaProv = gaProv;
        this.is_toggle = false;
        this.hide_back = true;
        this.is_close = false;
        this.returnMap = new EventEmitter();
        this.returnFavorite = new EventEmitter();
        this.resize = new EventEmitter();
        this.service_data = [];
        this.header_color = '#000000';
        this.header_background_color = '#4e8ef7';
        this.header_data = [];
        this.is_map_active = false;
        this.is_favorite_active = false;
        this.is_map_icon = false;
        this.main_list = [];
        this.sub_list = [];
        this.pc_data = [];
        this.top_tab_list = [];
        this.top_tab_active_index = 0;
        this.is_preview = 0;
        this.service_data = this.comProv.getService();
        this.is_pc = this.comProv.isPc();
        this.is_preview = this.comProv.getOptionsValue('is_preview');
        this.events.subscribe('drawer:set', function () {
            _this.setDrawer();
        });
    }
    CommonHeaderComponent.prototype.ngOnInit = function () {
        if (!this.comProv.platform.is('mobile')) {
            this.menu.enable(false);
        }
        this.is_login = this.comProv.isLogin();
        this.getTopTab();
        this.setHeader();
        this.setDrawer();
        if (this.page != 'PushIndexPage') {
            this.checkDailyAccess();
        }
    };
    CommonHeaderComponent.prototype.setDrawer = function () {
        if (this.top_tab_shop_id) {
            this.text = this.service_data['name'];
            return;
        }
        var drawer_list = this.comProv.getDrawer();
        var check_page = this.page;
        if (this.page == 'ShopDetailPage') {
            check_page = 'ShopIndexPage';
        }
        var drawer_data = drawer_list.find(function (item) {
            return (item['page_target'] == check_page);
        });
        if (drawer_data) {
            if (drawer_data['title']) {
                this.text = drawer_data['title'];
            }
        }
        drawer_list = drawer_list.filter(function (item) { return item['is_privated'] != 1; });
        var color_list = this.comProv.getColor();
        this.main_list = [];
        this.sub_list = [];
        drawer_list.forEach(function (item, index) {
            if (item['page_target'] == this.page) {
                item['is_active'] = true;
                item['color'] = color_list['button_background'];
                item['border_color'] = color_list['button_background'];
            }
            if (index < 6) {
                this.main_list.push(item);
            }
            else {
                this.sub_list.push(item);
            }
        }, this);
    };
    CommonHeaderComponent.prototype.setHeader = function () {
        var color_list = this.comProv.getColor();
        this.header_color = color_list['header_color'];
        this.header_background_color = color_list['header_background'];
        if ((this.page == 'HomePage' || this.page == 'SharePage' || this.top_tab_list.length || this.site_flg) && color_list['header_image']) {
            this.text = '';
            this.header_image = 'url(' + color_list['header_image'] + ')';
            var height = String(window.parent.screen.width / 6);
            if (this.site_flg && this.is_pc) {
                height = '120';
            }
            this.header_height = height + 'px';
        }
        if (color_list['header_image']) {
            this.header_image_url = color_list['header_image'];
        }
        if (this.page == 'HomePage') {
            this.header_data = this.comProv.getHeaderData();
        }
        this.pc_data = this.comProv.getPcData();
        // iOSフッター隙間対策
        if (localStorage.getItem('footer_background_color')) {
            var footer_background_color = localStorage.getItem('footer_background_color');
            var style_text = 'body{background-color:' + footer_background_color + ';}';
            var style = document.createElement('style');
            style.textContent = style_text;
            document.head.appendChild(style);
        }
    };
    CommonHeaderComponent.prototype.checkDailyAccess = function () {
        if (this.is_pc || !this.is_login) {
            return;
        }
        if (!this.service_data['is_score'] || !this.service_data['daily_access_score_rule']) {
            return;
        }
        var now_time = new Date().getTime();
        if (now_time < this.comProv.getTimestamp(this.service_data['daily_access_score_rule']['start_at'])) {
            return;
        }
        if (now_time > this.comProv.getTimestamp(this.service_data['daily_access_score_rule']['end_at'])) {
            return;
        }
        var access_day = this.comProv.getOptionsValue('access_day');
        var today = this.comProv.formatDate(new Date(), 'YYYY/MM/DD') + ' 00:00:00';
        if (!this.comProv.checkTime(access_day, today, null)) {
            return;
        }
        this.setDailyAccess();
    };
    CommonHeaderComponent.prototype.setDailyAccess = function () {
        var _this = this;
        this.apiProv.post(this.service_data['_links']['score']['daily_access_store']['href'])
            .then(function (data) {
            if (data['statusCode'] != '000') {
                _this.apiProv.detaError(data);
                return;
            }
            var access_day = data['data']['created_at'].replace(/-/g, '/').substr(0, 10) + ' 00:00:00';
            _this.comProv.setOptions('access_day', access_day);
        }).catch(function (error) {
            //this.apiProv.statusError(error, this.navCtrl);
        });
    };
    CommonHeaderComponent.prototype.setPush = function (new_push) {
        this.new_push = new_push;
    };
    CommonHeaderComponent.prototype.goPush = function () {
        if (location.hash == '#/push-index') {
            return;
        }
        this.navCtrl.setRoot('PushIndexPage');
    };
    CommonHeaderComponent.prototype.goPage = function () {
        var data = {
            url: this.header_data['header_icon_url1'],
            target: this.header_data['header_icon_target1'],
            current_page: this.page,
            category: 'ヘッダーアイコン'
        };
        this.comProv.goPage(data, this.navCtrl, this.gaProv);
    };
    CommonHeaderComponent.prototype.setShopMap = function () {
        if (this.is_map_active) {
            this.is_map_active = false;
        }
        else {
            this.is_map_active = true;
        }
        this.returnMap.emit(this.is_map_active);
    };
    CommonHeaderComponent.prototype.setShopFavorite = function () {
        if (this.is_favorite_active) {
            this.is_favorite_active = false;
        }
        else {
            this.is_favorite_active = true;
        }
        this.returnFavorite.emit(this.is_favorite_active);
    };
    CommonHeaderComponent.prototype.close = function () {
        this.viewCtrl.dismiss();
    };
    CommonHeaderComponent.prototype.goPagePc = function (item) {
        this.comProv.goPagePc(item, this.navCtrl, this.page);
    };
    CommonHeaderComponent.prototype.mouseOver = function (item) {
        var color_list = this.comProv.getColor();
        item['color'] = color_list['button_background'];
        item['border_color'] = color_list['button_background'];
    };
    CommonHeaderComponent.prototype.mouseOut = function (item) {
        if (item['is_active']) {
            return;
        }
        item['color'] = '#000000';
        item['border_color'] = '#ffffff';
    };
    CommonHeaderComponent.prototype.setMapIcon = function () {
        this.is_map_icon = true;
    };
    CommonHeaderComponent.prototype.getTopTab = function () {
        var _this = this;
        if (this.comProv.isPc()) {
            return;
        }
        if (!this.service_data['option']) {
            return;
        }
        if (!this.service_data['option']['is_top_tab']) {
            return;
        }
        if (this.service_data['option']['is_top_tab'] != '2') {
            if (!this.comProv.isLogin()) {
                return;
            }
        }
        if (!this.page) {
            return;
        }
        if (this.page != 'HomePage' && this.page.indexOf('FreeIndexPage-') !== 0) {
            return;
        }
        var top_tab_list = this.comProv.getTopTab();
        this.resize.emit();
        if (top_tab_list.length < 1) {
            return;
        }
        if (this.page.indexOf('FreeIndexPage-') === 0) {
            if (this.top_tab_shop_id < 1) {
                return;
            }
            var find_result = top_tab_list.find(function (item) {
                return (item['page_target'] == _this.page);
            });
            if (!find_result) {
                return;
            }
        }
        this.top_tab_list = top_tab_list;
        this.setTopTab();
    };
    CommonHeaderComponent.prototype.setTopTab = function () {
        var _this = this;
        var color_list = this.comProv.getColor();
        for (var i = 0; i < this.top_tab_list.length; i++) {
            var is_active = false;
            if (this.top_tab_list[i]['page_target'] == 'HomePage') {
                if (this.page == 'HomePage') {
                    is_active = true;
                }
            }
            else {
                if (this.top_tab_list[i]['id'] == this.top_tab_shop_id) {
                    is_active = true;
                }
            }
            if (is_active) {
                this.top_tab_list[i]['bottom_color'] = color_list['button_background'];
                this.top_tab_list[i]['font_weight'] = 'bold';
                this.top_tab_list[i]['is_active'] = true;
                this.top_tab_active_index = i;
            }
            else {
                this.top_tab_list[i]['bottom_color'] = 'transparent';
                this.top_tab_list[i]['font_weight'] = 'normal';
                this.top_tab_list[i]['is_active'] = false;
            }
            var tab_background_color = this.top_tab_list[i]['background_color'] ? this.top_tab_list[i]['background_color'] : color_list['header_background'];
            this.top_tab_list[i]['bg_img'] = 'linear-gradient(' + tab_background_color + ',' + tab_background_color + ')';
        }
        // タブメニューの移動
        setTimeout(function () {
            var index = _this.top_tab_active_index;
            var start = _this.top_tab_menu.nativeElement.scrollLeft;
            if (index > 0) {
                index = index - 1;
            }
            var end = _this.top_tab_menu.nativeElement.children[index].offsetLeft;
            var dir = 1;
            // 進行方向を決定(1：進む、-1：戻る)
            if (start > end) {
                dir = dir * -1;
            }
            // 移動量を決める。
            var speed = Math.abs(end - start) / 20;
            var cnt = 0;
            // endの位置に来るまでループ
            var obs = Observable.interval(1).subscribe(function (x) {
                cnt = cnt + (speed * dir);
                _this.top_tab_menu.nativeElement.scrollLeft = start + cnt;
                // 進む場合
                if ((start + cnt) >= end && dir == 1) {
                    obs.unsubscribe();
                }
                // 戻る場合
                if ((start + cnt) <= end && dir == -1) {
                    obs.unsubscribe();
                }
            });
        }, 1);
    };
    CommonHeaderComponent.prototype.changeTopTab = function (next_tab_data) {
        var now_tab_data = this.top_tab_list[this.top_tab_active_index];
        this.top_tab_shop_id = next_tab_data['id'] ? next_tab_data['id'] : null;
        if (this.service_data['option']['is_tab_start']) {
            if (next_tab_data['page_target'].indexOf('FreeIndexPage-') === 0) {
                var tab_start = { page_target: next_tab_data['page_target'], top_tab_shop_id: this.top_tab_shop_id };
                localStorage.setItem('tab_start', JSON.stringify(tab_start));
            }
            else if (next_tab_data['page_target'] == 'HomePage') {
                if (this.service_data['option']['is_top_tab'] == '2') {
                    // タブ起動クリア
                    this.comProv.deleteStorageData('tab_start');
                }
            }
        }
        if (next_tab_data['id'] != now_tab_data['id'] && next_tab_data['page_target'] == now_tab_data['page_target']) {
            this.setTopTab();
            return;
        }
        next_tab_data['target'] = next_tab_data['page_target'];
        next_tab_data['current_page'] = this.page;
        next_tab_data['category'] = 'ヘッダータブ';
        next_tab_data['top_tab_shop_id'] = this.top_tab_shop_id;
        this.comProv.goPage(next_tab_data, this.navCtrl, this.gaProv);
    };
    CommonHeaderComponent.prototype.getTabList = function () {
        var _this = this;
        if (this.comProv.isPc()) {
            return;
        }
        if (!this.service_data['option']['is_top_tab']) {
            return;
        }
        if (this.service_data['option']['is_top_tab'] != '2') {
            if (!this.comProv.isLogin()) {
                return;
            }
        }
        if (this.navCtrl['rootParams']['is_top_tab_list']) {
            return;
        }
        this.navCtrl['rootParams']['is_top_tab_list'] = true;
        if (this.service_data['option']['is_top_tab'] == '2') {
            this.apiProv.get(this.service_data['_links']['home_tabs']['href'])
                .then(function (data) {
                if (data['statusCode'] != '000') {
                    return;
                }
                var shop_list = data['data'];
                shop_list.forEach(function (item) {
                    item['background_color'] = null;
                    if (item['colors']) {
                        if (item['colors']['background_color']) {
                            item['background_color'] = item['colors']['background_color'];
                        }
                    }
                });
                _this.comProv.setTopTab(shop_list);
                _this.getTopTab();
            }).catch(function (error) {
            });
        }
        else {
            this.apiProv.get(this.service_data['_links']['shops']['href'], { light_mode: 1 })
                .then(function (data) {
                if (data['statusCode'] != '000') {
                    return;
                }
                var shop_list = data['data'];
                _this.comProv.setTopTab(shop_list);
                _this.getTopTab();
            }).catch(function (error) {
            });
        }
    };
    CommonHeaderComponent.prototype.cancelPreview = function () {
        this.comProv.setOptions('is_preview', 0);
        this.comProv.restart();
    };
    CommonHeaderComponent.prototype.restartPreview = function () {
        this.comProv.restart();
    };
    CommonHeaderComponent.prototype.historyBack = function () {
        if (history.length > 1) {
            history.back();
        }
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CommonHeaderComponent.prototype, "text", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CommonHeaderComponent.prototype, "page", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], CommonHeaderComponent.prototype, "is_toggle", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], CommonHeaderComponent.prototype, "hide_back", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CommonHeaderComponent.prototype, "icon_left", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], CommonHeaderComponent.prototype, "is_close", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], CommonHeaderComponent.prototype, "top_tab_shop_id", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], CommonHeaderComponent.prototype, "site_flg", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], CommonHeaderComponent.prototype, "returnMap", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], CommonHeaderComponent.prototype, "returnFavorite", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], CommonHeaderComponent.prototype, "resize", void 0);
    __decorate([
        ViewChild('top_tab_menu'),
        __metadata("design:type", Object)
    ], CommonHeaderComponent.prototype, "top_tab_menu", void 0);
    CommonHeaderComponent = __decorate([
        Component({
            selector: 'common-header',
            templateUrl: 'common-header.html',
        }),
        __metadata("design:paramtypes", [NavController,
            MenuController,
            ViewController,
            Events,
            CommonProvider,
            ApiProvider,
            AnalyticsProvider])
    ], CommonHeaderComponent);
    return CommonHeaderComponent;
}());
export { CommonHeaderComponent };
//# sourceMappingURL=common-header.js.map


// WEBPACK FOOTER //
// ./src/components/common-header/common-header.ts.pre-build-optimizer.js